/** Shared navigation for an idea's info and discussion pages. */
export default function NodePanelTabs({ activeTab, onInfo, onDiscuss, palette }) {
  return (
    <nav aria-label="Idea details" style={{ display: 'flex', gap: 4 }}>
      {['info', ...(onDiscuss ? ['discuss'] : [])].map(tab => (
        <button
          key={tab}
          type="button"
          aria-label={tab === 'info' ? 'Info' : 'Discuss'}
          aria-pressed={activeTab === tab}
          title={tab === 'info' ? 'Info' : 'Discuss'}
          onClick={tab === 'info' ? onInfo : onDiscuss}
          style={{
            width: 32, height: 30, display: 'grid', placeItems: 'center',
            border: 'none', borderRadius: 7, cursor: 'pointer',
            background: activeTab === tab ? palette.accent : 'transparent',
            color: activeTab === tab ? palette.accentText : palette.text,
            opacity: activeTab === tab ? 1 : 0.6,
          }}
        >
          <svg aria-hidden="true" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            {tab === 'info' ? <><circle cx="12" cy="12" r="9" /><path d="M12 11v6M12 7h.01" /></> : <path d="M21 11.5a8.5 8.5 0 0 1-8.5 8.5H4l-3 3V11.5a10 10 0 0 1 20 0ZM7 11h.01M11 11h.01M15 11h.01" />}
          </svg>
        </button>
      ))}
    </nav>
  );
}
